{
    "name": "@sashimo/lib",
    "version": "9.7.0",
    "description": "Tool to integrate AI admin tools into your application",
    "main": "dist/index.js",
    "module": "./dist/index.mjs",
    "types": "dist/index.d.ts",
    "repository": "",
    "keywords": [
        "ai",
        "admin-tools"
    ],
    "author": "Your Name <your.email@example.com>",
    "license": "MIT",
    "files": [
        "dist/**"
    ],
    "engines": {
        "zod": "<=3.25.67"
    },
    "scripts": {
        "build": "echo 'Starting build...' && tsc && tsup src/index.ts --format cjs, esm --dts&& echo 'Build completed!' ",
        "prepublish": "yarn build",
        "dev": "NODE_ENV=development tsup --watch",
        "lint": "TIMING=1 eslint --fix",
        "seed": "ts-node ./scripts/seed.ts",
        "test": "dotenv --  jest --passWithNoTests",
        "publish": "yarn build lint test && changeset version && changeset publish"
    },
    "peerDependencies": {
        "body-parser": "^1.19.0",
        "cors": "^2.8.5",
        "express": "^4.17.1",
        "zod": "<=3.25.67"
    },
    "devDependencies": {
        "@changesets/cli": "^2.27.7",
        "@types/body-parser": "^1.19.5",
        "@types/cors": "^2.8.17",
        "@types/express": "^4.17.21",
        "@types/jest": "^27.0.3",
        "@types/pg": "^8.11.6",
        "@types/supertest": "^6.0.2",
        "dotenv-cli": "latest",
        "eslint": "^8.33.0",
        "jest": "^29.7.0",
        "jest-fetch-mock": "^3.0.3",
        "supertest": "^7.0.0",
        "ts-jest": "^29.2.3",
        "tsup": "^6.1.2",
        "typescript": "^5.4.5"
    },
    "dependencies": {
        "@openai/agents": "^0.1.0",
        "@sentry/node": "8.34.0",
        "@sentry/profiling-node": "8.34.0",
        "axios": "^1.7.7",
        "body-parser": "^1.19.0",
        "chalk": "^4.1.2",
        "cors": "^2.8.5",
        "crypto": "^1.0.1",
        "dotenv": "^16.4.5",
        "express": "^4.17.1",
        "langfuse": "^3.28.0",
        "openai": "^4.53.2"
    }
}
